import scrollToItem from "./helpers/scrollToItem";

const hr = () => {
	if (!document.querySelector("#hr")) return;
	scrollToItem();

	const hrSelect = document.querySelector("#hr__select");
	const vacancies = document.querySelectorAll("[data-city]");

	hrSelect.addEventListener("change", (event) => {
		const { value } = event.target;
		if (!value) return;
		vacancies.forEach((vacancy) => {
			if (value === "all") {
				vacancy.classList.remove("d-none");
			} else if (value === vacancy.dataset.city) {
				vacancy.classList.remove("d-none");
			} else {
				vacancy.classList.add("d-none");
			}
		});
	});

	const requestButtons = document.querySelectorAll(`[data-bs-target="#hr-callback"]`);
	const vacancyInput = document.querySelector(`[data-target-name="vacancy"]`);
	if (requestButtons) {
		requestButtons.forEach((button) => {
			button.addEventListener("click", (event) => {
				if (event.target === button) {
					vacancyInput.value = button.dataset.vacancyName;
				}
			});
		});
	}
};

hr();

/**
 * Добавляем отступ от верха
 */
if (document.querySelector(".hr__nav")) {
	window.addEventListener("scroll", () => {
		if (document.querySelector(".hr__nav").style.top === `${document.querySelector("header").clientHeight}px`) return;

		document.querySelector(".hr__nav").style.top = `${document.querySelector("header").clientHeight}px`;
	});
}
